import { render, staticRenderFns } from "./SavingsPlan.vue?vue&type=template&id=1f33a2e2&scoped=true&"
import script from "./SavingsPlan.vue?vue&type=script&lang=js&"
export * from "./SavingsPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f33a2e2",
  null
  
)

export default component.exports